import { connect } from 'react-redux';
import AppSitePageStep from '../components/AppSitePageStep';
import { getAppSitePageStep } from '../selectors';
import { addFutureChanged, changeAppSiteSelection, stepValidationStatusChanged } from '../actions';

const mapStateToProps = state => getAppSitePageStep(state);

const mapDispatchToProps = dispatch => {
    return {
        onChange: (ids, value) => dispatch(changeAppSiteSelection(ids, value)),
        enableAddFuture: () => dispatch(addFutureChanged('app_site_id', true, true)),
        onStepValidationStatusChanged: stepValidationStatus =>
            dispatch(stepValidationStatusChanged(stepValidationStatus)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AppSitePageStep);
